import { useQuery } from "@apollo/client";
import { Row, Col, Switch, Select, Descriptions } from "antd";
import { useState } from "react";
import { EndpointMethodMetrics } from "../../components/endpoint/EndpointMethodMetrics";
import { EndpointMetrics } from "../../components/endpoint/EndpointMetrics";

import { ENUM_VALUES_QUERY } from "../../helpers/graphql/endpoint";
import { EndpointOriginMetrics } from "../../components/endpoint/EndpointOriginMetrics";
import { EndpointRegionMetrics } from "../../components/endpoint/EndpointRegionMetrics";
import { timeIntervalOption, timeRange } from "../../helpers/metrics.option";

export function EndpointInfo({ project }: any) {
  const [chain, setChain] = useState("cronos");
  const [network, setNetwork] = useState("mainnet");
  const [archive, setArchive] = useState(false);
  const [interval, setInterval] = useState("15m");
  const [showLast, setShowLast] = useState("_1d");

  const { loading: loadingList, data: chainAndNetworkData } = useQuery(ENUM_VALUES_QUERY);

  const chains = chainAndNetworkData?.chain.enumValues;
  const networks = chainAndNetworkData?.network.enumValues;

  return (
    <>
      {!loadingList ? (
        <Descriptions
          layout="vertical"
          colon={false}
          column={{ lg: 10, md: 10, sm: 5, xs: 2 }}
          labelStyle={{ alignItems: "center" }}
        >
          <Descriptions.Item label="Chain" span={1}>
            <Select
              size="small"
              value={chain}
              defaultValue={project?.id}
              onChange={(value) => setChain(value)}
              options={chains}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Network" span={1}>
            <Select
              size="small"
              value={network}
              onChange={(value) => setNetwork(value)}
              options={networks}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Interval" span={1}>
            <Select
              size="small"
              defaultValue={interval}
              onChange={(value) => setInterval(value)}
              options={timeIntervalOption}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Show last" span={1}>
            <Select
              size="small"
              defaultValue={showLast}
              onChange={(value) => setShowLast(value)}
              options={timeRange}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Node type" span={1}>
            <Switch
              defaultChecked
              checkedChildren="Full node"
              unCheckedChildren="Archive node"
              onChange={() => setArchive(!archive)}
            />
          </Descriptions.Item>
        </Descriptions>
      ) : null}
      <Row gutter={8}>
        <Col sm={24} md={24} lg={12} xl={12}>
          <EndpointMetrics
            project={project}
            network={network}
            chain={chain}
            archive={archive}
            interval={interval}
            showLast={showLast}
            height={190}
          />
        </Col>
        <Col sm={24} md={24} lg={12} xl={12}>
          <EndpointOriginMetrics
            project={project}
            network={network}
            chain={chain}
            archive={archive}
            interval={interval}
            showLast={showLast}
            height={190}
          />
        </Col>
        <Col sm={24} md={24} lg={12} xl={12}>
          <EndpointMethodMetrics
            project={project}
            network={network}
            chain={chain}
            archive={archive}
            interval={interval}
            showLast={showLast}
            height={190}
          />
        </Col>
        <Col sm={24} md={24} lg={12} xl={12}>
          <EndpointRegionMetrics
            project={project}
            network={network}
            chain={chain}
            archive={archive}
            interval={interval}
            showLast={showLast}
            height={190}
          />
        </Col>
      </Row>
    </>
  );
}
